/* import __COLOCATED_TEMPLATE__ from './fin-messenger-identity.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type { PulseAccordion } from 'glint/pulse';
import type RouterService from '@ember/routing/router-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';

export interface Args {
  accordion: PulseAccordion;
  closeAccordion: () => void;
}

export default class FinMessengerIdentity extends Component<Args> {
  @service declare router: RouterService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: any;

  get isIncomplete() {
    return !this.finStandaloneService.operatorIdentity;
  }

  get messengerSetupUrl() {
    return this.router.urlFor('apps.app.standalone.deploy.intercom-messenger.integrate', {
      queryParams: { section: this.standalonePlatform.isConnected ? 'fin-identity' : '' },
    });
  }

  get zendeskMessagingSetupUrl() {
    return this.router.urlFor('apps.app.standalone.deploy.zendesk.messaging.integrate', {
      queryParams: {
        section: this.standalonePlatform.isConnected ? 'zendesk-setup-fin-messenger-identity' : '',
      },
    });
  }

  get standalonePlatform() {
    return this.appService.mainStandalonePlatform;
  }

  get isDisabled() {
    return !this.standalonePlatform.isConnected;
  }

  get translationKey() {
    return `standalone.deploy.common.fin-messenger-identity-section.${this.standalonePlatform.platformKey}`;
  }

  @action goToMessengerSettings() {
    safeWindowOpen(this.router.urlFor('apps.app.settings.channels.messenger.general'), '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::FinMessengerIdentity': typeof FinMessengerIdentity;
    'standalone/common/fin-messenger-identity': typeof FinMessengerIdentity;
  }
}
